export default __webpack_public_path__ + "static/media/background.066b30a5.jpg";